var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/**
 * A pickup coin in a Coin Arena match. Lies on the floor plane (y is implicit
 * = arena floor height). `collectedBy` is the empty string until a player
 * picks it up, then the collecting player's session id.
 */
export class Coin extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.x = 0;
        this.z = 0;
        this.collectedBy = "";
    }
}
__decorate([
    type("string")
], Coin.prototype, "id", void 0);
__decorate([
    type("number")
], Coin.prototype, "x", void 0);
__decorate([
    type("number")
], Coin.prototype, "z", void 0);
__decorate([
    type("string")
], Coin.prototype, "collectedBy", void 0);
//# sourceMappingURL=Coin.js.map